export class TipoFechaPartoConstants
{
  static REAL = "Real";
  static PROBABLE = "Probable";
}
